import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AutomationInsights, Queue } from '@rossum/api-client/queues';
import { useIsFeatureEnabled } from '../../../../feature-enablement/featureEnablement';
import { automationAssistantSeletor } from '../../../../pricing/selectors';

/**
 * Centralized hook for all automation feature enablement logic.
 */
export const useAutomationFlags = () => {
  const isAutomationAssistantPurchased = useSelector(
    automationAssistantSeletor
  );

  const isAutomationV2Enabled = useIsFeatureEnabled(
    'mat-317-automation-settings-v2'
  );

  return useMemo(
    () => ({
      isAutomationV2Enabled,
      isAutomationAssistantPurchased,
      queueLevelFlags: {
        isAutomationConfident: (queue: Queue) =>
          queue.automationLevel === 'confident',
        isUsingAssistant: (queue?: Queue) =>
          Boolean(queue?.settings.automation?.automationAssistantEnabled),
        isAuroraQueue: ({
          automationInsights,
        }: {
          automationInsights: AutomationInsights | undefined;
        }) => Boolean(automationInsights?.isAuroraQueue),
      },
    }),
    [isAutomationV2Enabled, isAutomationAssistantPurchased]
  );
};
